import React from "react";
import { Pagination, Tag } from "@culturehq/components";
import client from "@culturehq/client";
import { useFetch, usePagination } from "app/hooks";

import { EventLink } from "app/links";
import { Trans } from "app/utils";
import { rsvpResponseTypeLabelFrom } from "constants/rsvpResponseTypes";

import ErrorMessage from "components/common/ErrorMessage";
import { TimeDiff } from "components/common/Time";
import ProfileTable from "./ProfileTable";

const EventRow = ({ event, user }) => (
  <tr>
    <td>
      <EventLink event={event}>
        {event.name}
        {user.id === event.host.id && (
          <>
            {" "}<Tag color="blue"><Trans>Host</Trans></Tag>
          </>
        )}
      </EventLink>
    </td>
    <td>
      <TimeDiff time={event.startsAt} />
    </td>
    <td>
      {rsvpResponseTypeLabelFrom(event.rsvpForOtherUser.responseType)}
    </td>
    <td>
      {event.host.name}
    </td>
  </tr>
);

const UserRsvpdEvents = ({ user }) => {
  const [page, onPageClick] = usePagination();
  const { error, fetching, json: { pagination = {}, events = [] } } = useFetch(
    () => client.listUserRsvpdEvents({ page, userId: user.id, sort: "-starts_at" }),
    [page, user]
  );

  return (
    <>
      <ProfileTable loading={fetching}>
        <thead>
          <tr>
            <th><Trans>Events</Trans></th>
            <th><Trans>Start Time</Trans></th>
            <th><Trans>RSVP Status</Trans></th>
            <th><Trans>Host</Trans></th>
          </tr>
        </thead>
        <tbody>
          {events.map(event => (
            <EventRow key={event.id} event={event} user={user} />
          ))}
          {events.length < 1 && (
            <tr>
              <td colSpan="4"><Trans>No events RSVP&#39;d</Trans></td>
            </tr>
          )}
          {error && (
            <tr>
              <td colSpan="4">{error && <ErrorMessage error={error} />}</td>
            </tr>
          )}
        </tbody>
      </ProfileTable>
      <Pagination {...pagination} onClick={onPageClick} />
    </>
  );
};

export default UserRsvpdEvents;
